import React from 'react';
import Footer from '@component/Footer';
import WBRString from '@component/WbrString';
import { RoutableLink } from '../../react/RoutableLink';
import EditableLink from '../../react/EditableLink';
import { Text, Image, Link, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';

const GlobalFooter = (props) => {
  const isEditing = props.sitecoreContext && props.sitecoreContext.pageEditing;

  const footerLinksFolderItemId = props.fields?.footerlinksfolder?.id;
  const footerLinksFolder = props.fields?.children?.find((e) => e.id === footerLinksFolderItemId);
  const socialLinksFolderItemId = props.fields?.sociallinksfolder?.id;
  const socialLinksFolder = props.fields?.children?.find((e) => e.id === socialLinksFolderItemId);

  var copyrightText = props.fields.footercopyright.value.replace('{{year}}', new Date().getFullYear());

  const links = [];
  footerLinksFolder?.fields?.children?.map((link, i) => {
    links.push(
      <>
        <RoutableLink field={link.fields.link} key={i} useATag={true}>
          <WBRString tag="span">
            <Text field={link.fields.linktext} />
          </WBRString>
        </RoutableLink>
        <EditableLink linkField={link.fields.link} isEditing={isEditing} />
      </>
    );
  });

  const socialLinks = [];
  socialLinksFolder?.fields?.children?.map((link, i) => {
    socialLinks.push(
      <>
        <RoutableLink field={link.fields.link} key={i} useATag={true}>
          <Image field={link.fields.socialicon} />
        </RoutableLink>
        <EditableLink linkField={link.fields.link} isEditing={isEditing} />
      </>
    );
  });

  return (
    <>
      <Footer
        footerLinks={links}
        footerCopyright={copyrightText}
        socialLinks={socialLinks}
        socialLinksHeading={
          <>
            <RoutableLink field={props.fields.sociallinksheadinglink} useATag={true}>
              <WBRString tag="span">
                <Text field={props.fields.sociallinksheading} />
              </WBRString>
            </RoutableLink>
            <EditableLink linkField={props.fields.sociallinksheadinglink} isEditing={isEditing} />
          </>
        }
        footerPrivacyPolicy={
          <>
            <RoutableLink field={props.fields.privacypolicylink} useATag={true}>
              <WBRString tag="span">
                <Text field={props.fields.privacypolicytext} />
              </WBRString>
            </RoutableLink>
            <EditableLink linkField={props.fields.privacypolicylink} isEditing={isEditing} />
          </>
        }
        footerTermsOfUse={
          <>
            <RoutableLink field={props.fields.termsofuselink} useATag={true}>
              <WBRString tag="span">
                <Text field={props.fields.termsofusetext} />
              </WBRString>
            </RoutableLink>
            <EditableLink linkField={props.fields.termsofuselink} isEditing={isEditing} />
          </>
        }
        footerLogoLink={
          props.fields?.footerlogo?.value?.src ? (
            <>
              <RoutableLink field={props.fields?.footerlogolink} useATag={true}>
                <Image field={props.fields?.footerlogo} editable={true} width="80" heigh="80" />
              </RoutableLink>
            </>
          ) : null
        }
      />
    </>
  );
};

export default withSitecoreContext()(GlobalFooter);
